export default __webpack_public_path__ + "static/media/cwa-vector.0bf9261e.webp";